import axios, { AxiosRequestConfig } from "axios";
import { store as storeConfig } from "../redux/storeConfig/store";
import { addContributor } from "../redux/actions/contributor";
import firebase from "firebase";
import { API_ENTREGAS } from "../Constants";

const addFirebaseIdToken = async (config: AxiosRequestConfig) => {
  const { contributor } = storeConfig.getState();

  const auth = firebase.auth();

  if (auth && auth.currentUser) {
    const tokenIdFirebase = await auth.currentUser.getIdToken(true);
    config.headers.Authorization = tokenIdFirebase;

    const user = { ...contributor };
    user.tokenIdFirebase = tokenIdFirebase;
    storeConfig.dispatch(addContributor(user));
  } else if (contributor && contributor.tokenIdFirebase) {
    config.headers.Authorization = contributor.tokenIdFirebase;
  }

  return config;
};

const orders = axios.create({
  baseURL: `${API_ENTREGAS}/orders`,
});
orders.interceptors.request.use(addFirebaseIdToken);

const groupOrders = axios.create({
  baseURL: `${API_ENTREGAS}/orders/grouping`,
});
groupOrders.interceptors.request.use(addFirebaseIdToken);

const ungroupOrders = axios.create({
  baseURL: `${API_ENTREGAS}/orders/ungrouping`,
});
ungroupOrders.interceptors.request.use(addFirebaseIdToken);

const store = axios.create({
  baseURL: `${API_ENTREGAS}/store`,
});
store.interceptors.request.use(addFirebaseIdToken);

const invoice = axios.create({
  baseURL: `${API_ENTREGAS}/invoices`,
});
invoice.interceptors.request.use(addFirebaseIdToken);

const invoiceGroup = axios.create({
  baseURL: `${API_ENTREGAS}/invoices-group`,
});
invoiceGroup.interceptors.request.use(addFirebaseIdToken);

const deliveryman = axios.create({
  baseURL: `${API_ENTREGAS}/deliveryman`,
});
deliveryman.interceptors.request.use(addFirebaseIdToken);

export {
  orders,
  groupOrders,
  ungroupOrders,
  store,
  invoice,
  invoiceGroup,
  deliveryman,
};
